import axios from 'axios';
const axiosInstance = axios.create({baseURL: process.env.REACT_APP_API_URI});
// axiosInstance.defaults.headers.common['Content-Type'] = 'multipart/form-data';

export default axiosInstance;